// JsFromRoutes CacheKey e41ecb9a234f6deebfcc4b1cbb144f76
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  list: definePathHelper('get', '/ping'),
}
